import {createAsyncThunk} from '@reduxjs/toolkit'

import {formatDateFns} from '@shared/helpers/date'
import {filterValueKeys} from '@shared/helpers/object'
import {qs} from '@shared/helpers/queryString'

import {historyChange, HistoryChangeAction} from '@web/actions/application'
import {getSettlementPayHold} from '@web/actions/saleSettlement'
import {ROUTER_ORDER_SALE_SETTLEMENT} from '@web/core/routes'
import {isErrorPayload} from '@web/helpers/api'

import {ThunkApi} from '../interfaces'
import {saleSettlementPayHoldDateSelector} from '../selectors'

const actionType = 'saleSettlementPayHold'

/** 정산 지급보류 초기화 action */
export const initSaleSettlementPayHold = createAsyncThunk<
    object,
    void,
    ThunkApi<{
        code: string
        message: string
    }>
>(`${actionType}/init`, async (_, {dispatch, getState, rejectWithValue}) => {
    const state = getState()

    const {initDate} = saleSettlementPayHoldDateSelector(state)

    try {
        await dispatch(
            getSettlementPayHold({
                startDate: initDate.startDate,
                endDate: initDate.endDate,
            }),
        ).unwrap()
    } catch (e) {
        if (isErrorPayload(e)) {
            return rejectWithValue({
                code: e.code,
                message: e.fallbackMessage,
            })
        }
        throw e
    }

    return {}
})

/** 정산 지급보류 날짜 변경 action */
export const changeSaleSettlementPayHoldDate = createAsyncThunk<
    {
        startDate: string
        endDate: string
    },
    {
        startDate: string
        endDate: string
    },
    ThunkApi<{
        code: string
        message: string
    }>
>(`${actionType}/changeDate`, async ({startDate, endDate}, {dispatch, rejectWithValue}) => {
    try {
        await dispatch(
            getSettlementPayHold({
                startDate,
                endDate,
            }),
        ).unwrap()
        const url = qs.stringifyUrlBySort<{
            startDate?: Maybe<string>
            endDate?: Maybe<string>
        }>({
            url: ROUTER_ORDER_SALE_SETTLEMENT.PAY_HOLD.getHref(),
            query: filterValueKeys((v) => !!v, {
                startDate: startDate ? formatDateFns(new Date(startDate), 'yyyy-MM') : null,
                endDate: endDate ? formatDateFns(new Date(endDate), 'yyyy-MM') : null,
            }),
            sorts: ['startDate', 'endDate'],
        })
        dispatch(
            historyChange({
                type: HistoryChangeAction.REPLACE_QUERY,
                url,
            }),
        )
    } catch (e) {
        if (isErrorPayload(e)) {
            return rejectWithValue({
                code: e.code,
                message: e.fallbackMessage,
            })
        }
        throw e
    }

    return {
        startDate,
        endDate,
    }
})
